import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { ALL_CLIENTS_KEY } from "../stores/org.store";

export interface PortalTimelineItem {
  id: string;
  kind: "appointment" | "invoice" | "document" | "request" | "message";
  at: string;
  title: string;
  subtitle: string | null;
  href: string;
  orgId: string;
  orgName: string | null;
}



export const usePortalTimeline = (activeClientId: string | null) => {
  const isAllProsMode = activeClientId === ALL_CLIENTS_KEY;
  return useQuery({
    queryKey: ["portal-timeline", activeClientId],
    queryFn: async () => {
      const { data } = await api.get<{ items: PortalTimelineItem[] }>(
        isAllProsMode ? "/portal/aggregate/timeline" : "/portal/timeline",
      );
      return data.items;
    },
  });
}
